import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { META_LANDING_URL_KEY } from "../constants.js";
import useRouteName from "./useRouteName.js";
const useRemoveExternalParamsFromUrl = () => {
    const history = useHistory();
    const routeName = useRouteName();
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let needsUpdate = false;
        if (routeName !== "flightdetails") {
            const caPrice = urlParams.get("ca_price") || "";
            if (caPrice) {
                urlParams.delete("ca_price");
                needsUpdate = true;
            }
        }
        const shouldClearMetaCurrencyParams = flightsSessionStore.get("salesCountry") && urlParams.get("selected_currency");
        if (shouldClearMetaCurrencyParams) {
            urlParams.delete("salesCountry");
            urlParams.delete("salesCurrency");
            flightsSessionStore.unset("salesCountry");
            flightsSessionStore.unset("salesCurrency");
            needsUpdate = true;
        }
        const metaChannel = urlParams.get("ext-origin") || "";
        if (metaChannel) {
            flightsSessionStore.set(META_LANDING_URL_KEY, window.location.href);
            urlParams.delete("ext-origin");
            urlParams.delete("ext-fwd");
            urlParams.delete("salesCountry");
            const metaChannelCustomerLocale = urlParams.get("customerLanguage") || "";
            if (metaChannelCustomerLocale) {
                urlParams.set("locale", metaChannelCustomerLocale.toLowerCase());
                urlParams.delete("customerLanguage");
            }
            needsUpdate = true;
        }
        if (needsUpdate) {
            history.replace(`${window.location.pathname}?${urlParams.toString()}${window.location.hash}`);
        }
    }, [history, routeName]);
};
export default useRemoveExternalParamsFromUrl;
